import { Component, OnInit, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { PatientVaccines } from '../../../models/consultation-history/patient-vaccines.model';
import { PatientVaccineSchedules } from '../../../models/consultation-history/patient-vaccine-schedules.model';
import { PatientOtherVaccines } from '../../../models/consultation-history/patient-other-vaccines.model';
import { DialogService } from '../../../shared/services/dialog.service';
import { ConsultationHistoryService } from '../consultation-history.service';
import { RecordPreviousVaccinePopupComponent } from './record-vaccination-popup.component';
import { VaccinationService } from './vaccination.service';
import { AppConstants } from '../../../shared/constants/constants';
@Component({
    selector: 'ch-vaccination',
    templateUrl: 'vaccination.component.html',
    providers: [VaccinationService, ConsultationHistoryService]
})

export class VaccinationComponent implements OnInit {
    @Input() history: boolean;
    // @Input() vaccines: {
    //     patientVaccines: PatientVaccines,
    //     patientVaccineSchedules: PatientVaccineSchedules,
    //     patientOtherVaccines: PatientOtherVaccines
    // };
    public appConstants = AppConstants;
    @Output() change: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() consultationId: string;
    @Input() patientId: string;
    public klass = 'consultationhistory';
    @Input() administedVaccines: any[];
    @Input() previousOtherVaccine: any[];
    @Input() vaccinationSchedules: any[];
    @Input() height: number;
    reload = false;
    constructor(public dialog: DialogService,
        public consultationHistoryService: ConsultationHistoryService,
        public vaccinationService: VaccinationService
    ) { }

    ngOnInit() {
        this.height = this.height ? (this.height > 600 ? this.height - 150 : this.height - 185) : null;
    }

    openRecordPreviousVaccinePopupComponent(vaccine: any) {
        const data = {
            patientId: this.patientId,
            id: this.consultationId
        };
        this.dialog.openComponentDialog(RecordPreviousVaccinePopupComponent, data, { width: '80%' }).subscribe(result => {
            if (result) {
                // this.patientPreviousOtherVaccine();
                this.change.emit(true);
            }
        });
    }

    @HostListener('ngModelChange', ['$event'])
    onModelChange(event) {
        // if(this.reload) {
        //     this.change.emit(this.reload);
        // }
    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-history/vaccination/vaccination.component.ts